import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	addOrganizations: {
		id: 'servicedesk-customers.header-actions.add-organizations-dialog.add-organizations',
		defaultMessage: 'Add organizations',
		description: 'button for adding organizations',
	},
});
